import React, { StrictMode } from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import SearchBox from './containers/SearchBox'
import { PAGE_HOTELS_LIST } from '../../constants'
import { isDesktop } from '../../helpers/browser'
import store from '../shared/store'

/**
 * Search box with filters used for AB test on home page
 * If  Cookie present filters are enabled
 * and video banner for desktop applied html/src/js/components/homePageBanner
 * Created on base of search component styles
 *
 * @param searchBoxData<Object> - window.drupalSettings.widgets.searchBox
 * @param filtersData<Object>   - window.drupalSettings.widgets.filters
 * @param filtersTypes<Array>   - possible values ['dates', 'rooms', 'more', 'code']
 * @param activeFilter<String>  - defines the opened by default filter if is set.
 *                                Possible: 'dates', rooms', 'more'
 * @param pageIndex<Number>     - The index of current HTML page
 * @param containerId<String>   - id of root DOM element for search app.
 * @param sticky<Boolean>       - should search bar be sticky on page scroll
 *
 * @returns {*}
 */
const searchBox = ({
  searchBoxData,
  filtersData,
  filtersTypes,
  activeFilter,
  pageIndex = PAGE_HOTELS_LIST,
  containerId = 'search-box',
  sticky = false,
}) => {
  const container = (document.getElementById('search-box-mobile') && !isDesktop()) ? 'search-box-mobile' : containerId

  render(
    <StrictMode>
      <Provider store={store}>
        <SearchBox
          searchBoxData={searchBoxData}
          filtersData={filtersData}
          filtersTypes={filtersTypes}
          activeFilter={activeFilter}
          pageIndex={pageIndex}
          sticky={sticky}
        />
      </Provider>
    </StrictMode>,

    document.getElementById(container),
  )
}

export default searchBox
